import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="kit-lines-expansion"
export default class extends Controller {
  static values = { resultId: Number }
  static targets = ["indicator"]
  
  toggle(event) {
    event.preventDefault();

    const kitLineGroup = document.querySelectorAll(`.kit_line-details-${this.resultIdValue}`);
    kitLineGroup.forEach(line => line.classList.toggle("hidden"));

    this.indicatorTarget.classList.toggle("glyphicon-triangle-bottom");
    this.indicatorTarget.classList.toggle("glyphicon-triangle-right");
  }
}
